import * as React from "react"
import { Icon } from "@material-ui/core"

interface IProps {
    icon: string,
    iconSize?: number;
    iconDirection?: string;
}

export const MediaCard: React.SFC<IProps> = (props) => {
  return (
    <div style={{display: 'flex', flexDirection: 'row'}}>
        <div 
            style={{ 
                ...props.iconDirection && { alignSelf: props.iconDirection}
            }}
        >
            <Icon
                style={{ 
                    ...props.iconSize && {fontSize: props.iconSize}
                }}
            >
                {props.icon}
            </Icon>
        </div>

        <div style={{padding: '0 1rem', flex: 1}}>
            {props.children}
        </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/shared/MediaCard/MediaCard.tsx